<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    persistent
  >
    <v-card data-cy="card_sucesso_reembolso">
      <v-card-title
        class="title pt-5 pb-0"
        primary-title
      >
        Solicitar reembolso
      </v-card-title>

      <div>
        <v-card-text
          v-if="respostaSuccess"
          class="pt-3"
          data-cy="texto_sucesso_reembolso"
        >
          <p>
            Sua solicitação foi enviada ao vendedor <strong>{{ produtor }}</strong>.
            Lembramos que ela será analisada em até  <strong>10 (dez) dias </strong>.
          </p>
          <p>
            Este prazo está de acordo com o Procon, que concede 10 (dez) dias às empresas
            para responderem às reclamações feitas pelos consumidores.
          </p>
        </v-card-text>

        <v-card-text
          v-else
          class="pt-3"
        >
          <p>
            Desculpe, ocorreu um erro. Por favor, tente novamente mais tarde.
          </p>
        </v-card-text>
      </div>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          data-cy="fechar_sucesso_reembolso"
          @click="limparStore()"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ModalSolicitarReembolso',

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    respostaSuccess: {
      type: Boolean,
      required: true,
    },
    produtor: {
      type: String,
      required: true,
    },
  },

  methods: {
    limparStore() {
      this.$store.dispatch('setDadosCompra', {});
      this.$router.push('/minhas-compras');
    },
  },
};
</script>
